import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminBulkPaymentLinksPage() {
  const [data, setData] = useState({ batches: [], total: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admin/bulk-payment-links');
      setData(r.data || { batches: [], total: 0 });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to load bulk payment usage');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-40"><div className="w-6 h-6 border-2 border-emerald-700 border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>Bulk Payment Links Usage</h1>
          <p className="text-slate-500 text-sm mt-0.5">View bulk upload activity across accounts.</p>
        </div>
        <Button variant="outline" onClick={load} className="gap-2">
          <RefreshCw size={16} /> Refresh
        </Button>
      </div>

      <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
        <CardHeader>
          <CardTitle className="text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>Recent Batches</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Owner</TableHead>
                <TableHead>File</TableHead>
                <TableHead>Rows</TableHead>
                <TableHead>Links</TableHead>
                <TableHead>Created</TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {(data.batches || []).map((batch) => (
                <TableRow key={batch.id}>
                  <TableCell>
                    <div className="font-medium text-slate-900">{batch.owner_business_name || batch.owner_name || 'Unknown owner'}</div>
                    <div className="text-xs text-slate-500">{batch.owner_email || batch.user_id}</div>
                  </TableCell>
                  <TableCell>{batch.source_filename || '-'}</TableCell>
                  <TableCell>{batch.total_rows || 0}</TableCell>
                  <TableCell><Badge className="bg-emerald-100 text-emerald-800">{batch.created_link_count || batch.created_links?.length || 0}</Badge></TableCell>
                  <TableCell>{batch.created_at ? new Date(batch.created_at).toLocaleString() : '-'}</TableCell>
                  <TableCell className="text-right text-xs text-slate-500">Read-only usage view</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
